<template>
  <div class="max-w-7xl mx-auto p-2 my-2 rounded-lg">
    <div class="grid grid-cols-1 gap-3">
      <div class="p-3 bg-gray-50 shadow rounded-lg">
        <div class="capitalize flex justify-between">
          <h1 class="text-xl font-medium">{{ noteState.type === 'collection' ? 'Collection by Customer' : 'To be Delivered' }}</h1>
          <div v-if="noteState.order">
            <EditDeliveryNoteModal
              :is-order="false"
              v-if="canAdmin('update-dispatch-notes') && noteState.status !== 'void' && noteState.status !== 'completed' && (noteState.order.status === 'invoiced' || noteState.order.status === 'delivery_in_progress')"
              v-slot="{open}"
              :note="noteState"
              :order="noteState.order"
              :key="'edit-delivery-note-'+noteState.id"
              @close="fetchItems"
            >
              <button
              type="button"
              class="btn-primary px-3 py-2"
              @click="open"
              :disabled="!canAdmin('update-dispatch-notes') && noteState.order.is_locked"
            >
              Edit
            </button>
            </EditDeliveryNoteModal>
          </div>
        </div>

        <DeliveryItems
          v-model="form.items"
          :items="items"
          :note="note"
        />
        <OtherWarehouseItems
          v-if="otherItems.length"
          heading="Other Teams"
          :note="note"
          :warehouses="otherItems"
        />
      </div>
      <div class="col-span-full">
        <div class="w-full flex justify-end gap-x-2">
          <HandoverToCustomerModal
            :note="note"
            :items="form.items"
            :can-handover-items-to-customer="canHandoverToCustomer"
            v-slot="{open}"
            :handover-route="route('delivery-note.handover.team-customer', {
              note: note.id,
              order: note.order_id,
            })"
            @close="resetSelection"
          >
            <button
              class="btn-primary"
              @click="open"
              :disabled="form.items.length === 0"
            >
              Handover
            </button>
          </HandoverToCustomerModal>
          <a :href="route('delivery-notes.print-schedule', {
                      note: note.id,
                      order: note.order_id,
                    })"
             class="btn-primary" target="_blank">
            Print
          </a>
          <a
            :href="route('customer.orders.download-file', {customerOrder: note.order_id, file: 'quotation', preview: 'preview' })"
            class="btn-primary" target="_blank">
            Invoice
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryItems from "./DeliveryItems.vue";
import HandoverToCustomerModal from "../HandoverToCustomerModal.vue";
import OtherWarehouseItems from "../OtherWarehouseItems.vue";
import EditDeliveryNoteModal from "../../../CustomerOrders/Partials/DeliveryNotes/EditDeliveryNoteModal.vue";

export default {
  name: 'DeliveryDetails',
  components: {EditDeliveryNoteModal, OtherWarehouseItems, HandoverToCustomerModal, DeliveryItems},

  props: {
    note: Object,
    filters: Object,
  },

  data() {
    return {
      noteState: this.note || {},
      otherItems: [],
      items: [],
      form: {
        items: [],
      }
    }
  },

  computed: {
    canHandoverToCustomer() {
      return this.canAdmin([
        'update-dispatch-notes',
        'delivery-team-role',
        'access-delivery-teams',
        'warehouse-manager-role',
      ]) && this.note.status === 'in-progress' || this.note.type === 'collection'
    }
  },

  methods: {
    scrollTo() {
      const element = document.getElementById(`note-${this.note.id}`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    fetchItems() {
      this.$nextTick(() => {
        this.$http.get(this.route('ajax.delivery-notes.get-items', {
          note: this.note.id,
          team: this.filters.team || null,
          warehouse: this.filters.warehouse || null
        }))
          .then(resp => {
            this.items = resp.data.data
            this.otherItems = resp.data.others
            this.noteState = resp.data.note || this.note
            this.$nextTick(() => {
              this.scrollTo();
            });
          })
      })
    },

    resetSelection() {
      this.form.items = []
      this.fetchItems()
    },
  },

  mounted() {
    this.fetchItems()
  }
}
</script>
